import React, { useState, useEffect } from "react";
import Style from "../style/loginpopup.module.scss";

const RECAPTCHA_SITE_KEY = "6LceBDgrAAAAAAV2ifaCyCdzCDJh1U2MpnfZ2rng";

declare global {
  interface Window {
    grecaptcha: {
      execute: (
        siteKey: string,
        options: { action: string }
      ) => Promise<string>;
      ready: (callback: () => void) => void;
    };
  }
}

const LoginPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [recaptchaReady, setRecaptchaReady] = useState(false);
  const [isFormTouched, setIsFormTouched] = useState(false); // Track if the form is interacted with

  useEffect(() => {
    const hasShown = sessionStorage.getItem("hasShownLoginPopup");
    if (!hasShown) {
      const timer = setTimeout(() => {
        setIsOpen(true);
        sessionStorage.setItem("hasShownLoginPopup", "true");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  // Load reCAPTCHA only after form interaction
  useEffect(() => {
    if (isFormTouched && !recaptchaReady) {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.onload = () => {
        window.grecaptcha.ready(() => {
          setRecaptchaReady(true);
          console.log("reCAPTCHA ready.");
        });
      };
      script.onerror = () => {
        console.error("Failed to load reCAPTCHA.");
      };
      document.head.appendChild(script);
    }
  }, [isFormTouched, recaptchaReady]);

  const handleClose = () => setIsOpen(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!recaptchaReady || !window.grecaptcha) {
      alert("reCAPTCHA not ready. Please try again.");
      return;
    }

    try {
      const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {
        action: "login",
      });

      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password, captcha: token }),
      });

      const result = await response.json();

      if (result.success) {
        handleClose();
      } else {
        alert("Login failed or bot detected");
      }
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsFormTouched(true);
    const { name, value } = e.target;
    if (name === "email") setEmail(value);
    else if (name === "password") setPassword(value);
  };

  return (
    <>
      {isOpen && (
        <div className={Style.popupOverlay}>
          <div className={Style.popupContainer}>
            <button className={Style.closeBtn} onClick={handleClose}>
              &times;
            </button>
            <h2 className={Style.popupTitle}>Welcome Back 👋</h2>
            <p className={Style.subtitle}>Please login to continue</p>
            <form onSubmit={handleSubmit}>
              <div className={Style.inputGroup}>
                <input
                  type="email"
                  value={email}
                  onChange={handleInputChange}
                  name="email"
                  placeholder="Email"
                  required
                  className={Style.input}
                />
              </div>
              <div className={Style.inputGroup}>
                <input
                  type="password"
                  value={password}
                  onChange={handleInputChange}
                  name="password"
                  placeholder="Password"
                  required
                  className={Style.input}
                />
              </div>

              <button type="submit" className={Style.submitBtn}>
                🚀 Login
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginPopup;
